
const PRINT_PUBLISH_DATE_FORMAT = 'MM/dd/yy HH:mm';
const PLAN_DATE_REPORT_FORMAT = 'MM/dd/yyyy'

export { PRINT_PUBLISH_DATE_FORMAT, PLAN_DATE_REPORT_FORMAT };
